const FINANCIAL_UPLOAD_DOC_TYPE_IDS = new Set([
  "financial-report",
  "financial-statement",
  "audited-financials",
  "management-financials",
]);

export const FINANCIAL_UPLOAD_MAX_PAGE_COUNT = 150;
export const FINANCIAL_UPLOAD_PAGE_LIMIT_MESSAGE = `Uploaded PDF must be ${FINANCIAL_UPLOAD_MAX_PAGE_COUNT} pages or less.`;

const normalizeDocTypeId = (value?: string | null): string =>
  (value ?? "").toLowerCase().trim().replace(/_/g, "-");

export const isFinancialUploadDocumentType = (
  documentType?: string | null,
): boolean =>
  FINANCIAL_UPLOAD_DOC_TYPE_IDS.has(normalizeDocTypeId(documentType));

export const withFinancialUploadPageLimitHint = (
  description?: string | null,
  documentType?: string | null,
): string => {
  if (!isFinancialUploadDocumentType(documentType)) {
    return (description ?? "").trim();
  }

  const normalizedDescription = (description ?? "").trim();
  if (!normalizedDescription) {
    return FINANCIAL_UPLOAD_PAGE_LIMIT_MESSAGE;
  }

  const hasPageLimitText = /150\s*pages?/i.test(normalizedDescription);
  if (hasPageLimitText) {
    return normalizedDescription;
  }

  return `${normalizedDescription} ${FINANCIAL_UPLOAD_PAGE_LIMIT_MESSAGE}`;
};

const isFinancialPageLimitError = (errorMessage?: string): boolean => {
  if (!errorMessage) {
    return false;
  }

  const normalizedError = errorMessage.toLowerCase();
  const hasPageKeyword = /page|pages|page\s*count/.test(normalizedError);
  const has150LimitKeyword =
    /150|one\s*hundred\s*(and\s*)?fifty|max(imum)?\s*pages?|too\s*many\s*pages|pages?\s*or\s*less/.test(
      normalizedError,
    );

  return hasPageKeyword && has150LimitKeyword;
};

export const resolveDocumentUploadErrorMessage = ({
  errorMessage,
  duplicateDocumentMessage,
  isFinancialDocumentType,
}: {
  errorMessage?: string;
  duplicateDocumentMessage: string;
  isFinancialDocumentType?: boolean;
}): string => {
  if (!errorMessage) {
    return "Something went wrong while uploading document.";
  }

  if (errorMessage.startsWith("Duplicate document")) {
    return duplicateDocumentMessage;
  }

  if (isFinancialDocumentType && isFinancialPageLimitError(errorMessage)) {
    return FINANCIAL_UPLOAD_PAGE_LIMIT_MESSAGE;
  }

  return errorMessage;
};
